import React, { useEffect, useState } from 'react'
import { isPE } from '../Device'
import classnames from 'classnames'
import s from './SlideInOut.less'

type SlideInOutPropsType = { display: boolean; children: (className?: string) => React.ReactNode }

const SlideInOut: React.FC<SlideInOutPropsType> = ({ display, children }) => {
  const [shouldRender, setShouldRender] = useState(display)
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    if (display) {
      setShouldRender(true)
      const timer = setTimeout(() => {
        setIsActive(true)
      }, 50)
      return () => clearTimeout(timer)
    } else if (shouldRender) {
      setIsActive(false)
      const timer = setTimeout(() => {
        setShouldRender(false)
      }, 300)
      return () => clearTimeout(timer)
    }
  }, [display, shouldRender])

  if (__BROWSER__ && isPE()) {
    if (!shouldRender) return <></>
    const className = classnames(s.slideInOut, isActive && s.slideInActive)
    return children(className)
  }

  if (!display) return <></>

  return <div className={display ? s.show : s.hide}>{children()}</div>
}

export default SlideInOut
